import React from 'react'

import InfoIcon from '@src/components/icons/Info'
import SandDollarIcon from '@src/components/icons/SandDollar'
import { SAND_DOLLARS_WIDGET_TOOLTIP } from '@src/constants/exchange'
import { ISandDollarsData } from '@src/types/order'
import { createSandDollarsBalance } from '@src/utils/sandDollars'

interface ISandDollarsTrackerProp {
    sandDollars: ISandDollarsData
    isStablecoinSwap?: boolean
    tooltipPosition?: 'left' | 'bottom'
}

const SandDollarsTracker: React.FC<ISandDollarsTrackerProp> = ({
    sandDollars,
    isStablecoinSwap = false,
    tooltipPosition = 'bottom',
}: ISandDollarsTrackerProp) => {
    const [showTooltip, setShowTooltip] = React.useState(false)

    // Create Balance object from sand dollars data
    const sandDollarsBalance = createSandDollarsBalance(sandDollars)

    return (
        <div
            className={`animate-fade-in-up flex flex-1 items-center gap-2 rounded-[10px] bg-[#381601] p-2 ${isStablecoinSwap ? '!opacity-30' : ''}`}
        >
            <div className='flex flex-1 items-center gap-2'>
                <SandDollarIcon height='16' width='16' />
                <span className='text-fluid-sm !leading-5 text-[#FF6200]'>
                    +{sandDollarsBalance?.formatWithMagnitudes(5) || '0'} Sand Dollars
                </span>
            </div>
            <div
                className='relative'
                onMouseEnter={() => !isStablecoinSwap && setShowTooltip(true)}
                onMouseLeave={() => !isStablecoinSwap && setShowTooltip(false)}
            >
                <InfoIcon className={`h-4 w-4 text-[#FF6200] ${isStablecoinSwap ? '' : 'cursor-help'}`} />
                {showTooltip && !isStablecoinSwap && (
                    <div
                        className={`absolute z-[60] inline-flex w-64 transform flex-col items-start justify-start gap-2 rounded-md bg-[#212326] p-4 opacity-100 shadow-[0px_10px_30px_rgba(0,0,0,0.35)] ${
                            tooltipPosition === 'left'
                                ? 'right-full top-1/2 mr-2 -translate-y-1/2'
                                : 'left-1/2 top-full mt-2 -translate-x-1/2'
                        }`}
                    >
                        <div className='break-words text-center text-xs font-normal leading-4 text-[#757575]'>
                            {SAND_DOLLARS_WIDGET_TOOLTIP}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default SandDollarsTracker
